import type { StyleRules, Theme } from '~/utils/withStyles';

const profileStyles = (theme: Theme) => ({
  profileDivider: {
    margin: `${theme.spacing(4)}px 0`,
  },
  profileLinks: {
    textAlign: 'center',
  },
} as const satisfies StyleRules);

export default profileStyles;
